import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { hardReloadForUpdate } from '@/utils/appVersionCheck';

export function AppUpdateBanner({ updateAvailable, runningVersion, latestVersion, onDismiss }) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (updateAvailable) {
      setDismissed(false);
    }
  }, [updateAvailable, latestVersion, runningVersion]);

  if (!updateAvailable || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[100] border-t border-indigo-200 bg-indigo-950 text-white shadow-2xl"
      role="region"
      aria-label="App update available"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:py-3.5">
        <div className="min-w-0 pr-2">
          <p className="text-sm font-bold sm:text-base">A new version of the app is available</p>
          <p className="mt-0.5 text-xs text-indigo-100 sm:text-sm">
            Tap update to load the latest version. If the page does not refresh automatically, use
            the button below.
            {runningVersion && latestVersion ? (
              <span className="mt-1 block text-indigo-200/90">
                You have {runningVersion} · Latest {latestVersion}
              </span>
            ) : null}
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={() => void hardReloadForUpdate(latestVersion)}
            className="inline-flex items-center gap-2 rounded-xl bg-white px-4 py-2.5 text-sm font-black text-indigo-900 hover:bg-indigo-50"
          >
            <RefreshCw className="h-4 w-4" aria-hidden />
            Update now
          </button>
          <button
            type="button"
            onClick={handleDismiss}
            className="inline-flex items-center justify-center rounded-xl border border-indigo-400/50 p-2.5 text-indigo-100 hover:bg-indigo-900"
            aria-label="Dismiss update notice"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
